import { Injectable } from '@angular/core';
import {FilterProductPreview} from "../interface/filter-product-preview";

@Injectable({
  providedIn: 'root'
})
export class FilterSortService {

	constructor() {
	}


	private _quantitySorting(a: FilterProductPreview, b: FilterProductPreview): number {
		return (
			(b.total_quantity > 0 || b.made_to_order_fabric_quantity > 0 ||
				(b.product_size_profile_option_list && b.product_size_profile_option_list[0]?.quantity > 0))
				? 1 : 0
		) - (
			(a.total_quantity > 0 || a.made_to_order_fabric_quantity > 0 ||
				(a.product_size_profile_option_list && a.product_size_profile_option_list[0]?.quantity > 0))
				? 1 : 0
		);
	}

	private _isMainProductSorting(a: FilterProductPreview, b: FilterProductPreview): number {
		return Number(b.is_main_product) - Number(a.is_main_product);
	}

	private _isLatestProductSorting(a: FilterProductPreview, b: FilterProductPreview): number {
		return b.id - a.id;
	}

	private _lowToHighPrice(a: FilterProductPreview, b: FilterProductPreview): number {
		return a.calculatedPrice - b.calculatedPrice;
	}

	private _highToLowPrice(a: FilterProductPreview, b: FilterProductPreview): number {
		return b.calculatedPrice - a.calculatedPrice;
	}

	public sortByAvailability(filterResult: FilterProductPreview[]): FilterProductPreview[] {
		return filterResult.sort((a: FilterProductPreview, b: FilterProductPreview) => {
			const quantitySorting = this._quantitySorting(a, b);

			if (quantitySorting === 0) {
				const mainProductComparison =  this._isMainProductSorting(a, b);

				if (mainProductComparison === 0) {
					return this._isLatestProductSorting(a, b);
				}

				return mainProductComparison;
			}
			return quantitySorting;
		});
	}


	public sortByDate(filterResult: FilterProductPreview[]): FilterProductPreview[] {
		return filterResult.sort((a: FilterProductPreview, b: FilterProductPreview) => {
			const latestProductSorting = this._isLatestProductSorting(a, b);

			if (latestProductSorting === 0) {
				const mainProductComparison =  this._isMainProductSorting(a, b);

				if (mainProductComparison === 0) {
					return this._quantitySorting(a, b);
				}

				return mainProductComparison;
			}
			return latestProductSorting;
		});
	}

	public sortByLowPrice(filterResult: FilterProductPreview[]): FilterProductPreview[] {
		return filterResult.sort((a: FilterProductPreview, b: FilterProductPreview) => {
			const lowToHighPrice = this._lowToHighPrice(a, b);

			if (lowToHighPrice === 0) {
				const mainProductComparison =  this._isMainProductSorting(a, b);

				if (mainProductComparison === 0) {
					return this._quantitySorting(a, b);
				}

				return mainProductComparison;
			}
			return lowToHighPrice;
		});
	}


	public sortByHighPrice(filterResult: FilterProductPreview[]): FilterProductPreview[] {
		return filterResult.sort((a: FilterProductPreview, b: FilterProductPreview) => {
			const highToLowPrice = this._highToLowPrice(a, b);

			if (highToLowPrice === 0) {
				const mainProductComparison =  this._isMainProductSorting(a, b);

				if (mainProductComparison === 0) {
					return this._quantitySorting(a, b);
				}

				return mainProductComparison;
			}
			return highToLowPrice;
		});
	}
}
